import { Location, locationName } from '@cobliteam/common-types';

import { lazy } from '@cobliteam/lazy-with-retries';

const AIRouter = lazy(() => import('@cobliteam/ai'));
const AIAutomations = lazy(() => import('@cobliteam/ai/src/pages/AIAutomations'));
const AIAutomationRuns = lazy(() => import('@cobliteam/ai/src/pages/AIAutomationRuns'));
const AIFiles = lazy(() => import('@cobliteam/ai/src/pages/AIFiles'));
const AITrust = lazy(() => import('@cobliteam/ai/src/pages/AITrust'));
const AIConfig = lazy(() => import('@cobliteam/ai/src/pages/AIConfig'));
const AIConnectors = lazy(() => import('@cobliteam/ai/src/pages/AIConnectors'));

const routes = [
  {
    title: locationName[Location.AI],
    path: Location.AI,
    component: AIRouter,
    featureFlag: 'aiChat',
    exact: false,
    routes: [
      {
        title: locationName[Location.AI_AUTOMATION],
        path: Location.AI_AUTOMATION,
        component: AIAutomations,
        featureFlag: 'aiAutomations',
        exact: true,
      },
      {
        title: locationName[Location.AI_AUTOMATION_RUNS],
        path: Location.AI_AUTOMATION_RUNS,
        component: AIAutomationRuns,
        featureFlag: 'aiAutomations',
        exact: true,
      },
      {
        title: locationName[Location.AI_FILES],
        path: Location.AI_FILES,
        component: AIFiles,
        featureFlag: 'aiChat',
        exact: true,
      },
      {
        title: locationName[Location.AI_TRUST],
        path: Location.AI_TRUST,
        component: AITrust,
        featureFlag: 'aiChat',
        exact: true,
      },
      {
        title: locationName[Location.AI_CONFIG],
        path: Location.AI_CONFIG,
        component: AIConfig,
        featureFlag: 'aiConfig',
        exact: true,
      },
      {
        title: locationName[Location.AI_CONNECTORS],
        path: Location.AI_CONNECTORS,
        component: AIConnectors,
        featureFlag: 'aiComposio',
        exact: true,
      },
    ],
  },
];

export default routes;
